import { render, staticRenderFns } from "./ReviewPanel.vue?vue&type=template&id=5e905df4&scoped=true"
import script from "./ReviewPanel.vue?vue&type=script&lang=js"
export * from "./ReviewPanel.vue?vue&type=script&lang=js"
import style0 from "./ReviewPanel.vue?vue&type=style&index=0&id=5e905df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e905df4",
  null
  
)

export default component.exports